/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';

prestashop.responsive = prestashop.responsive || {};

prestashop.responsive.current_width = window.innerWidth;
prestashop.responsive.min_width = 768;
prestashop.responsive.min_width_menu = 992;
prestashop.responsive.mobile = prestashop.responsive.current_width < prestashop.responsive.min_width;
prestashop.responsive.mobile_menu = prestashop.responsive.current_width < prestashop.responsive.min_width_menu;

function swapChildren(obj1, obj2)
{
	var temp = obj2.children().detach();
	obj2.empty().append(obj1.children().detach());
	obj1.append(temp);
}

function toggleMobileStyles()
{
	if (prestashop.responsive.mobile) {
		$("*[id^='_desktop_']").each(function(idx, el) {
			var target = $('#' + el.id.replace('_desktop_', '_mobile_'));
			if (target.length) {
				swapChildren($(el), target);
			}
		});
        $('[data-collapse-hide-mobile]').collapse('hide');
        
 
 /***review sur fiche produit***/       
    if ($('.tabs ._desktop_tab-pane_review').length) {
		 swapChildren($('.tabs ._desktop_tab-pane_review'), $('.tabs ._mobile_tab-pane_review'));
     $('.tabs ._mobile_tab-pane_review').attr('id',$('.tabs ._desktop_tab-pane_review').attr('id'));
     $('.tab-content.visible--mobile').attr('id',$('.tab-content.visible--desktop').attr('id'));      
    /* $('.tabs ._desktop_tab-pane_review').remove();
     $('.tab-content.visible--desktop').remove();*/

		}
        

    } else {
		$("*[id^='_mobile_']").each(function(idx, el) {
			var target = $('#' + el.id.replace('_mobile_', '_desktop_'));
			if (target.length) {
				swapChildren($(el), target);
			}

		});
		
        $('[data-collapse-hide-mobile]').not('.show').collapse('show');
        $('[data-modal-hide-mobile].show').modal('hide');

    }

  /*  if (prestashop.responsive.mobile_menu) {
    	$("*[id='_desktop_top_menu']").each(function(idx, el) {
			var target = $('#' + el.id.replace('_desktop_', '_mobile_'));
			console.log("tata"+'#' + el.id.replace('_desktop_', '_mobile_'));
			if (target.length) {
				swapChildren($(el), target);
			}
		});
       
    }*/

	prestashop.emit('responsive update', {
		mobile: prestashop.responsive.mobile
	});
}

$(window).on('resize', function() {
	var _cw = prestashop.responsive.current_width;
	var _mw = prestashop.responsive.min_width;
	var _w = window.innerWidth;
	var _toggle = (_cw >= _mw && _w < _mw) || (_cw < _mw && _w >= _mw);
	prestashop.responsive.current_width = _w;
  prestashop.responsive.mobile = prestashop.responsive.current_width < prestashop.responsive.min_width;
  prestashop.responsive.mobile_menu = prestashop.responsive.current_width < prestashop.responsive.min_width_menu;
	if (_toggle) {
		toggleMobileStyles();
	}
});

$(document).ready(function() {
	if (prestashop.responsive.mobile) {
		$(".visible_desktop").remove();
	/*	$('#main .visible--desktop').remove();*/

 		toggleMobileStyles();
//	$('.product-tabs .visible--desktop .nav-tabs').remove();
		
	} else {
		/*if(prestashop.responsive.mobile_menu) {
			toggleMobileStyles();	
		}*/
//		$(".visible_mobile").remove();
		$('.product-tabs .visible--mobile').remove();
	/*		$(".visible_mobile").remove();*/
		/*	$('#main .visible--mobile').remove();*/
	}
});
